import type { AppointmentView } from '@masterzapis/types';
import { durationLabel } from '../format';

interface Props {
  appointments: AppointmentView[];
  busyId: string | null;
  onCancel: (appointment: AppointmentView) => void;
  onReschedule: (appointment: AppointmentView) => void;
  onBook: () => void;
}

export function MyAppointments({
  appointments,
  busyId,
  onCancel,
  onReschedule,
  onBook,
}: Props) {
  if (appointments.length === 0) {
    return (
      <div className="empty-state">
        <p>Здесь появятся ваши визиты.</p>
        <button className="button" onClick={onBook}>
          Записаться
        </button>
      </div>
    );
  }

  return (
    <div>
      <p className="section-title">Предстоящие визиты</p>
      {appointments.map((appointment) => (
        <div key={appointment.id} className="card" style={{ cursor: 'default' }}>
          <span className="card-row">
            <span className="card-name">{appointment.serviceName}</span>
            <span className="card-price">{appointment.priceFormatted}</span>
          </span>
          <span className="card-meta">
            {appointment.date}, {appointment.time} ·{' '}
            {durationLabel(appointment.durationMinutes)}
          </span>
          <span className="card-meta status">{appointment.statusLabel}</span>

          {(appointment.canReschedule || appointment.canCancel) && (
            <div className="actions">
              {appointment.canReschedule && (
                <button
                  className="button secondary"
                  disabled={busyId === appointment.id}
                  onClick={() => onReschedule(appointment)}
                >
                  Перенести
                </button>
              )}
              {appointment.canCancel && (
                <button
                  className="button danger"
                  disabled={busyId === appointment.id}
                  onClick={() => onCancel(appointment)}
                >
                  Отменить
                </button>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
